﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareXContract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const ShareXABI_1 = require("./abi/ShareXABI");
class ShareXContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, ShareXABI_1.ShareXABI.GetABI());
    }
    deposite(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const wei = this._toWei(value);
            const res = yield this._pay(wei, "deposite");
            return res;
        });
    }
    name() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("name");
        });
    }
    symbol() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("symbol");
        });
    }
    totalSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("totalSupply");
            return res;
        });
    }
    transfer(to, amountEth) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('transfer', to, this._web3.utils.toWei(amountEth, "ether"));
        });
    }
    balanceOf(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("balanceOf", address);
            return res;
        });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalance");
            return this._toEther(res);
        });
    }
    getBalanceToken(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalanceToken", address);
            return this._toEther(res);
        });
    }
    getConsumedBalance(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getConsumedBalance", address);
            return this._toEther(res);
        });
    }
    getConsumedBalanceETH() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getConsumedBalanceETH");
            return this._toEther(res);
        });
    }
    getCost(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getCost", address);
            return this._toEther(res);
        });
    }
    getCostETH() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getCostETH");
            return this._toEther(res);
        });
    }
    getShareCost(shareAddress, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getShareCost", shareAddress, tokenAddress);
            return this._toEther(res);
        });
    }
    getShareCostETH(shareAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getShareCostETH", shareAddress);
            return this._toEther(res);
        });
    }
    consumeIncomeETH() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("consumeIncomeETH"); });
    }
    consumeIncomeERC20(address) {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("consumeIncomeERC20", address); });
    }
    withdrawETH() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("withdrawETH"); });
    }
    withdrawERC20(address) {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("withdrawERC20", address); });
    }
}
exports.ShareXContract = ShareXContract;
//# sourceMappingURL=ShareXContract.js.map